<template>
  <PrescriptionPage :config="config" />
</template>

<script>
import PrescriptionPage from "@/components/smallComponents/PrescriptionPage.vue";

export default {
  components: { PrescriptionPage },
  data() {
    return {
      config: {
        pageTitle: "处方信息",
        fetchApi: "/api/health/v2/prescription",
        fetchGroupedApi: "/api/health/v2/prescription",
        useGroupedApi: true,
        relRecordApi: "/api/health/v2/rela/record",
        replaceApi: "/api/health/v1/prescription/replace",
        replaceSubmitApi: "/api/health/v1/prescription/replace/submit",
        replaceResultApi: "/api/health/v1/prescription",
        showSymptoms: true,
        showGanZhi: true,
        // tabs: ["开方信息", '针灸信息', '本草压片', '通用方信息'],
        tabs: ["开方信息", '本草茶饮', '本草压片'],
        showAiButtonOnAllTabs: true,
        showGenerateOnAllPrescriptionTabs: true,
        hasShanghanTab: true,
        showMainTabCard: false,
        generateRoute: "/prescriptionImage",
      },
    };
  },
};
</script>
